const FilterDirection = (props) => {
  const { direction } = props;

  if (direction === "asc") {
    return <span className="archive__filter-arrow">&uarr;</span>;
  } else {
    return <span className="archive__filter-arrow">&darr;</span>;
  }
};

export default FilterDirection;
